import { SyntheticEvent, useCallback, useEffect, useState } from 'react';

import { Button, Typography } from 'antd';

import { useTheme } from '@emotion/react';

import fallbackbanner from '@/assets/images/fallbackbanner.png';
import { getCdnUrl } from '@/helpers';
import { useAppSelector } from '@/hooks/redux';
import { useLog } from '@/hooks/useLog';
import { useUpsell } from '@/hooks/useUpsell';
import { IShowcaseBannerUpsell } from '@/interfaces/upsell';
import styled, { StyledProp, css } from '@/styled';

import OfferContainer from '../Container';
import SeeMore from '../SeeMore';

const Offer = (props: StyledProp & { upsell: IShowcaseBannerUpsell }) => {
  const user = useAppSelector(({ auth }) => auth.user);
  const openCheckout = useUpsell(props.upsell, { utm_medium: 'DESTAQUE' });
  const [modalSeeMore, setModalSeeMore] = useState(false);
  const { log } = useLog();
  const { breakpoints } = useTheme();
  const handleLog = useCallback(
    (action: 'click' | 'view') => {
      log('upsellnew', {
        action,
        id: props.upsell.id,
        hash_checkout: props.upsell.hash,
        viewd: 'highlight',
        producer_id: props.upsell.producer.id,
        user_id: user.id
      });
    },
    [log, user, props.upsell]
  );
  const openOffer = (event: SyntheticEvent) => {
    handleLog('click');
    openCheckout(event);
  };

  const showMoreInfo = () => {
    setModalSeeMore(!modalSeeMore);
  };

  useEffect(() => {
    handleLog('view');
  }, [handleLog]);

  const Image = (
    <>
      <source
        media={breakpoints.down('lg')}
        srcSet={getCdnUrl(props.upsell.highlight_images?.medium, fallbackbanner)}
      />
      <source media={breakpoints.down('sm')} srcSet={getCdnUrl(props.upsell.highlight_images?.small, fallbackbanner)} />
      <img
        src={getCdnUrl(props.upsell.highlight_images?.large, fallbackbanner)}
        alt={'Imagem da oferta do curso: ' + props.upsell.title}
      />
    </>
  );

  return (
    <OfferContainer image={Image}>
      <>
        <Typography.Title className='titleOffer' level={1} ellipsis={true}>
          {props.upsell.title}
        </Typography.Title>
        <Typography.Paragraph className='resumeOffer' ellipsis={{ rows: 2 }}>
          {props.upsell.description}
        </Typography.Paragraph>
        <div className='containerButtonsOffers'>
          <Button onClick={openOffer} className='handleButtonOffer'>
            {props.upsell.label_text ?? 'Saiba Mais'}
          </Button>
          <Button onClick={showMoreInfo} className='handleButtonSeeMore'>
            Mais informações
          </Button>
        </div>
        <SeeMore
          title={props.upsell.title}
          description={props.upsell.description}
          active={modalSeeMore}
          setActive={showMoreInfo}
        />
      </>
    </OfferContainer>
  );
};

export default styled(Offer)`
  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      display: none;
    }

    .handleButtonOffer {
      height: 40px;
      background-color: ${theme.palette.alpha(theme.palette.gray[12], 0.65)};
      padding: 8px 16px;
    }

    .offerCover {
      position: relative;

      &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        background-image: linear-gradient(90deg, ${theme.palette.gray[11]} 0%, rgba(20, 20, 20, 0) 50%),
          linear-gradient(0deg, ${theme.palette.gray[11]} 0%, rgba(20, 20, 20, 0) 50%);
      }

      img {
        width: 100%;
        aspect-ratio: 4 / 1;
        object-fit: cover;
      }
    }
  `}
`;
